import { projectTableResponseSchema, projectDetailSchema, listProjectsDataTableParamsSchema, projectFilterOptionsQuerySchema, projectFilterOptionsResponseSchema, projectCoverageSchema, projectCoverageRescanResponseSchema, } from '../contracts/projects';
import { serializeTableQueryParams } from '../contracts/table';
import { parseSchema } from '../errors';
import { organizationIdSchema, } from '../contracts/organizations';
/**
 * Fetch projects in DataTable format (pagination, filters, sorting, search).
 *
 * Sends filters using bracket notation via serializeTableQueryParams.
 * The response follows the standard DataTable shape: { data, pagination, meta }.
 */
export async function listProjectsDataTable(client, organizationId, params = {}, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listProjectsDataTableParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/inventory/projects`, {
        params: validatedParams,
        paramsSerializer: serializeTableQueryParams,
        signal: options?.signal,
    });
    return parseSchema(projectTableResponseSchema, response);
}
/**
 * Fetch a single project by its slug (the single-project page).
 */
export async function getProjectBySlug(client, organizationId, slug, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/inventory/projects/${encodeURIComponent(slug)}`, { signal: options?.signal });
    return parseSchema(projectDetailSchema, response);
}
/**
 * Fetch a project's security-coverage payload for the single-project page
 * (KIR-3517): project metadata, last scan time, summary counts, and every
 * enabled catalog category with its per-project status.
 */
export async function getProjectCoverage(client, organizationId, slug, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/inventory/projects/${encodeURIComponent(slug)}/coverage`, { signal: options?.signal });
    return parseSchema(projectCoverageSchema, response);
}
/**
 * Queue a fresh coverage scan for a project (KIR-3516). Returns once the scan
 * job is enqueued (202) — poll/refetch `getProjectCoverage` for the outcome.
 */
export async function rescanProjectCoverage(client, organizationId, slug) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedId}/inventory/projects/${encodeURIComponent(slug)}/coverage/rescan`);
    return parseSchema(projectCoverageRescanResponseSchema, response);
}
/**
 * Fetch distinct filter-option values (name or repo URL) for the Projects
 * DataTable column filters. Paginated + searchable, like the Extensions name
 * filter.
 */
export async function getProjectFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(projectFilterOptionsQuerySchema, params);
    const response = await client.get(`/organizations/${validatedId}/inventory/projects/filter-options`, { params: validatedParams });
    return parseSchema(projectFilterOptionsResponseSchema, response);
}
//# sourceMappingURL=projects.js.map